import React from 'react';
import {
  ArrayLayoutProps,
  composePaths,
  isObjectArrayWithNesting,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { withJsonFormsArrayLayoutProps } from '@jsonforms/react';
import merge from 'lodash/merge';

import ArrayRenderer from './ArrayRenderer';

export const ArrayLayoutRenderer = ({
  uischema,
  schema,
  renderers,
  cells,
  data,
  path,
  config,
}: ArrayLayoutProps) => {
  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  const toRender = Array(data)
    .fill(0)
    .map((_, i) => {
      return (
        <ArrayRenderer
          key={i}
          index={i}
          schema={schema}
          uischema={uischema}
          path={composePaths(path, `${i}`)}
          renderers={renderers}
          cells={cells}
          childLabelProp={appliedUiSchemaOptions.elementLabelProp}
        />
      );
    });
  return <div>{toRender}</div>;
};

export const arrayLayoutTester: RankedTester = rankWith(
  5,
  isObjectArrayWithNesting,
);
export default React.memo(withJsonFormsArrayLayoutProps(ArrayLayoutRenderer));
